import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/content";
import { getByType } from "@/utils/content";
import type { ContentType } from "@/types/content";

const accentMap: Record<string, string> = {
  plot: "bg-primary-50 text-primary-600",
  character: "bg-accent-50 text-accent-600",
  news: "bg-secondary-100 text-secondary-700",
};

export default function CategoryEntries() {
  return (
    <section className="relative z-20 w-full px-4 md:px-8">
      <div className="max-w-[1200px] mx-auto -mt-14 md:-mt-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {categoryMeta.map((cat) => {
            const count = getByType(cat.type as ContentType).length;
            return (
              <Link
                key={cat.type}
                to={`/category/${cat.type}`}
                className="group flex items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className={`shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${accentMap[cat.type]}`}>
                  <i className={`${cat.icon} text-2xl`}></i>
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-400">{count} 篇</span>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.desc}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                    进入分类
                    <span className="w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}